import StatusBadge from 'components/atoms/status-badge'
import { LIVE_PROCESS_STATUS } from 'domains/seller-inbound/constants'
import PropTypes from 'prop-types'
import React from 'react'

const proptypes = {
  live_process_status: PropTypes.string
}

/**
 * To give nice look on Seller Inbound `live_process_status`.
 * It maps `live_process_status` to certain style and pass to `StatusBadge`.
 * @param {string} live_process_status Seller Inbound live process status. available values
 * - `pending`
 * - `ready_live`
 * - `completed`
 */
const SellerInboundLiveProcessStatusBadge = ({ live_process_status }) => {

  const colorMap = {
    [LIVE_PROCESS_STATUS.PENDING]    : 'warning',
    [LIVE_PROCESS_STATUS.READY_LIVE] : 'info',
    [LIVE_PROCESS_STATUS.COMPLETED]  : 'success'
  }

  const color = colorMap[live_process_status] || 'default'

  return <StatusBadge color={ color } label={ live_process_status } />
}

SellerInboundLiveProcessStatusBadge.propTypes = proptypes

export default SellerInboundLiveProcessStatusBadge
